import { render, staticRenderFns } from "./add-client-modal.vue?vue&type=template&id=09f8c6f1"
import script from "./add-client-modal.vue?vue&type=script&lang=js"
export * from "./add-client-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports